import { BrowserRouter, Routes, Route } from "react-router-dom"
import Login from "./pages/Login"
import AssignedTrips from "./pages/AssignTrips"
import TripDetails from "./pages/TripDetaild"
import "./styles/Common.scss"
import ProtectedLayout from "./ProtectedLayout"
import { TripSheet } from "./pages/TripSeet"
import BusSchedule from "./pages/BusSchedule"
import { PassengerBoarding } from "./pages/passengerBoarding"
import { ViewChart } from "./pages/ViewChart"
import { useAtomValue } from "jotai"
import { globalLoaderAtom } from "./jotaiState/globalStateAtoms"
import { alertAtom } from "./jotaiState/globalStateAtoms"
import LoaderScreen from "./components/common/loader"
import Alert from "./components/common/alert"

const App = () => {
  const loader = useAtomValue(globalLoaderAtom)
  const alert = useAtomValue(alertAtom)
  return (
    <BrowserRouter>
      {loader && <LoaderScreen />}
      {alert?.show && <Alert {...alert} />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/passenger-boarding" element={<PassengerBoarding />} />
        <Route element={<ProtectedLayout />}>
          <Route path="/assigned-trips" element={<AssignedTrips />} />
          <Route path="/trip-details" element={<TripDetails />} />
          <Route path="/trip-sheet" element={<TripSheet />} />
          <Route path="/bus-schedule" element={<BusSchedule />} />
          <Route path="/view-chart" element={<ViewChart />} />
          <Route path="*" element={<AssignedTrips />} />
        </Route>
        <Route path="*" element={<ProtectedLayout />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
